import { Navigate, useLocation, type Location } from "react-router-dom";
import { useIsAuthenticated, useAuth } from "../hooks/useAuth";
import { LoginForm } from "../components/auth/LoginForm";

export function Login() {
  const isAuthenticated = useIsAuthenticated();
  const { loading } = useAuth();
  const location = useLocation();
  const fromLocation = (location.state as { from?: Location } | null)?.from;
  const from = fromLocation
    ? `${fromLocation.pathname}${fromLocation.search}${fromLocation.hash}`
    : "/home";

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(37,99,235,0.10),_transparent_45%),linear-gradient(180deg,_#f8fafc,_#eef2ff)]">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-600 border-t-transparent" />
      </div>
    );
  }
  if (isAuthenticated) return <Navigate to={from} replace />;

  return (
    <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(37,99,235,0.10),_transparent_45%),linear-gradient(180deg,_#f8fafc,_#eef2ff)] px-4 py-10">
      <div className="w-full max-w-md rounded-[28px] border border-slate-200 bg-white/95 p-3 shadow-[0_20px_60px_-24px_rgba(15,23,42,0.25)] backdrop-blur">
        <LoginForm />
      </div>
    </div>
  );
}
